import { SupportedSplTokens } from "../types";

export const tokens = new Map<SupportedSplTokens | "sol" | "usdc", string>([
  ["sol", "So11111111111111111111111111111111111111112"],
  ["usdc", "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"],
  ["str", "5P3giWpPBrVKL8QP8roKM7NsLdi3ie1Nc2b5r9mGtvwb"],
  ["dust", "DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ"],
  ["samo", "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU"],
  ["shdw", "SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y"],
]);
